// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import moment from 'moment'

const NO_DELTA_CHANGE = '--'

const millisecondsToMinutes = milliseconds => moment.duration(milliseconds, 'milliseconds').asMinutes().toFixed(0)

const calculateChangePercentage = function(previousValue, newValue) {
  if (!!!previousValue && !!!newValue) { return 0 }
  if (!!!previousValue) { return NO_DELTA_CHANGE }
  return (((newValue - previousValue) / previousValue) * 100).toFixed(1)
}

const millisecondsToDuration = function(milliseconds) {
  const duration = moment.duration(milliseconds, 'milliseconds')
  const minutes = duration.asMinutes().toFixed(0)

  if (minutes > (24 * 60)) {
    return `${ (minutes / (24 * 60)).toFixed(1) } days`
  } else if (minutes > 60) {
    return `${ (minutes / 60).toFixed(1) } hours`
  } else {
    return `${minutes}m ${duration.seconds()}s`
  }
}

const toISOLocalDateString = date => moment(date).format('YYYY-MM-DD')

const compareSameImmutableTimePeriods = (timePeriodA, timePeriodB) => key => (
  timePeriodA !== null && timePeriodB !== null && timePeriodA.get(key).isSame(timePeriodB.get(key))
)

const areSameImmutableTimePeriods = (timePeriodA, timePeriodB) => {
  const isSame = compareSameImmutableTimePeriods(timePeriodA, timePeriodB)
  return isSame('startDate') && isSame('endDate') && isSame('prevStart') && isSame('prevEnd')
}

export {
  NO_DELTA_CHANGE,
  areSameImmutableTimePeriods,
  millisecondsToMinutes,
  calculateChangePercentage,
  millisecondsToDuration,
  toISOLocalDateString
}



// WEBPACK FOOTER //
// ./src/scripts/utils/DateHelpers.js